/**
 * Filter players to remove disabled ones
 * @param {Array} players - List of players
 * @returns {Array} Filtered list with only enabled players
 */
export function filterEnabledPlayers(players) {
  if (!Array.isArray(players)) return [];
  return players.filter((p) => p.player_enabled === true);
}

/**
 * Filter object of players by ID
 * @param {Object} playersByPosition - Object with position keys mapping to arrays of players
 * @returns {Object} Filtered object
 */
export function filterEnabledPlayersByPosition(playersByPosition) {
  if (!playersByPosition || typeof playersByPosition !== "object") return {};
  const filtered = {};
  for (const [key, value] of Object.entries(playersByPosition)) {
    if (Array.isArray(value)) {
      filtered[key] = filterEnabledPlayers(value);
    } else {
      filtered[key] = value;
    }
  }
  return filtered;
}
